module.exports = __webpack_public_path__ + "static/media/fruit-apple.f6e6b387.png";